import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api';

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', passwort: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (user) navigate(user.rolle === 'trainer' ? '/trainer/gruppen' : '/', { replace: true });
  }, [user, navigate]);

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.passwort) {
      setError('E-Mail und Passwort sind Pflicht');
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/api/auth/login', { email: form.email, passwort: form.passwort });
      login(res.data.token, res.data.user);
      navigate(res.data.user.rolle === 'trainer' ? '/trainer/gruppen' : '/', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Anmeldung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">🏊</div>
        <h1 className="login-title">SwimDesk</h1>
        <p className="login-subtitle">SV Grevenbroich e.V. – Administration</p>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit} className="login-form" noValidate>
          <div className="form-group">
            <label className="form-label">E-Mail-Adresse</label>
            <input
              type="email" name="email" value={form.email} onChange={handleChange}
              className="form-control" autoComplete="email" autoFocus
            />
          </div>
          <div className="form-group">
            <label className="form-label">Passwort</label>
            <input
              type="password" name="passwort" value={form.passwort} onChange={handleChange}
              className="form-control" autoComplete="current-password"
            />
          </div>
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Anmelden…' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
}
